<template>
  <div class="int-wrap" :style="{ backgroundImage: `url(${bg || showObj.bg})` }">
    <svg-icon v-if="isClose" class="int-close" icon="close" @click.native="close" />
    <div>
      <p class="title">
        学员正在参与
      </p>
      <div class="desc">
        {{ showObj.name }}
      </div>
    </div>
    <div class="common-content">
      <slot />
    </div>
    <p class="count-down" v-if="isCountDown">
      <span>{{ realCountdown }}</span>秒后关闭
    </p>
    <div class="common-bottom">
      <slot name="bottom" />
    </div>
  </div>
</template>
<script>
import { computed, onMounted } from '@vue/composition-api'
import getCountDown from './countdown'
import VIDEO_ASK from '@/components/VideoPlayer/images/VIDEO_ASK.svg'
import ALL_RESPONSE from '@/components/VideoPlayer/images/ALL_RESPONSE.svg'
import redAudio from '@/components/VideoPlayer/images/redAudio.svg'
import plane from '@/components/VideoPlayer/images/plane.svg'
import ti from '@/components/VideoPlayer/images/ti.svg'
import { EXTRA_TIME } from './constant'
export default {
  props: {
    event: Object,
    addTime: {
      type: Number,
      default: EXTRA_TIME // eslint-disable-line vue/valid-define-props
    },
    isCountDown: {
      type: Boolean,
      default: true
    },
    isClose: {
      type: Boolean,
      default: false
    },
    bg: String
  },
  setup(props, { root, refs, emit }) {
    const typeMap = {
      104: {
        name: '语音红包互动',
        bg: redAudio
      },
      105: {
        name: '语音评测互动',
        bg: VIDEO_ASK
      },
      121: {
        name: '一呼百应互动',
        bg: ALL_RESPONSE
      },
      128: {
        name: '单步训练',
        bg: ti
      },
      129: {
        name: '歼灭飞机读单词',
        bg: plane
      }
    }
    const showObj = computed(() => (typeMap[props.event.type]) || {})
    // 显示时长为生产平台实际配置时长单位秒+3s反馈时长
    const { realCountdown, start } = getCountDown(props.addTime)
    onMounted(() => {
      const { event } = props
      const { params } = event
      const { duration } = params
      console.log('***', duration)
      // 开始倒计时
      if (props.isCountDown) {
        start(
          duration,
          () => {
            // 倒计时结束
            emit('realEnd', event)
          },
          () => {
            // 额外添加的倒计时结束
            emit('end', event)
          }
        )
      }
    })
    function close() {
      console.log(11111)
      emit('realEnd', props.event)
    }
    return {
      showObj,
      realCountdown,
      close
    }
  }
}
</script>
<style lang="less" scoped>
.int-wrap {
  min-width: 327px;
  border-radius: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  padding: 40px 40px 0 40px;
  background: #fff right bottom no-repeat;
  .int-close {
    font-size: 24px;
    position: absolute;
    top: 16px;
    right: 24px;
    cursor: pointer;
    :deep(svg) {
      fill: #98A2B2;
    }
  }
  .title {
    font-size: 16px;
    color: #70788C;
  }
  .desc {
    font-weight: 700;
    font-size: 28px;
    line-height: 37px;
    color: #303858;
  }
  .common-content {
    min-height: 40px;
  }
  :deep(.que-wrap) {
    width: 520px;
    background: #F5F7F9;
    border-radius: 12px;
    overflow: hidden;
    margin: 20px 0;
  }
  :deep(.que-inner) {
    color: #505873;
    overflow-y: overlay;
    box-sizing: border-box;
    margin: 24px 0;
    padding: 0 24px;
    margin-right: 4px;
    padding-right: 20px;
    max-height: 306px;
    &::-webkit-scrollbar {
      width: 6px;
      height: 14px;
      background-color: #98A2B2;
    }
    &::-webkit-scrollbar-thumb{
        width: 6px;
        height: 6px;
        opacity: 0.8;
        border-radius: 3px;
        background: #98A2B2;
        margin-right: -6px;
    }
    &::-webkit-scrollbar-track {
        background: #F5F7F9;
    }
    &::-webkit-scrollbar-button {
        background: #F5F7F9;
    }
    &::-webkit-scrollbar-corner {
        background: #F5F7F9;
    }
  }
  .count-down {
    font-size: 15px;
    color: #70788c;
    padding-bottom: 40px;
    font-weight: 400;
    span {
      color: #f05a6e;
    }
  }
}
</style>
